"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Currencies = void 0;
/**
 * Currency values to use across MyFrey platform
 */
exports.Currencies = [
    { currencyCode: "USD", currencyName: "US Dolar", currencySymbol: "$" },
    { currencyCode: "CAD", currencyName: "Canadian dollar", currencySymbol: "$" },
    { currencyCode: "AUD", currencyName: "Australian dollar", currencySymbol: "$" },
];
